export function void0() {
  return void 0;
}
